import { ArrowLink } from "../components/Shell";

export default function NotFoundPage() {
  return (
    <section className="not-found">
      <div>
        <strong>404</strong>
        <h1>페이지를 찾을 수 없습니다.</h1>
        <p>주소를 다시 확인해 주세요.</p>
        <ArrowLink to="/">홈으로 돌아가기</ArrowLink>
      </div>
    </section>
  );
}
